import { render } from "./BulkAction.vue?vue&type=template&id=5167fd21&scoped=true"
import script from "./BulkAction.vue?vue&type=script&lang=js"
export * from "./BulkAction.vue?vue&type=script&lang=js"

import "./BulkAction.vue?vue&type=style&index=0&id=5167fd21&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5167fd21"]])

export default __exports__